import { nextTick, defineComponent, ref, provide, reactive, toRefs, getCurrentInstance, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import PageLoading from '@/components/common/PageLoading.vue';
import HeaderVR from '@/components/layout/header_vr.vue';
import Footer from '@/components/layout/footer.vue';
import Menu from '@/components/layout/menu.vue';
import Swiper from '@/components/layout/Swiper.vue';
import bus from 'vue3-eventbus';
import SideComponent from '@/components/common/SideComponent.vue';
import Loading from '@/components/common/Loading.vue';
import { wexinShare, getWechatShareImgUrl } from '@/utils/wxshare.js';
import { trackContentView, CONTENT_VIEW_TYPES } from '@/utils/contentView.js';

export default defineComponent({
	components: {
		HeaderVR,
		Menu,
		Footer,
		PageLoading,
		Swiper,
		SideComponent,
	},
	setup() {
		provide('logoColor', 'black');
		const { proxy } = getCurrentInstance();
		const route = useRoute();
		const id = route.query.id;
		const data = reactive({
			isLoading: true,
			loginStyle: 'min-width:141px;',
			mobileIconStyle: 'color:rgba(223, 58, 8, 1);',
			showListIcon: true,
			taleDetail: {},
			isListLoading: true,
			views: 0,
		});

		const showMenus = ref(proxy.$menus);
		provide('showMenu', showMenus);
		provide('menuTextStyle', { color: '#fff' });
		provide('showHeader', false);

		const store = useStore();
		const getInternationalDetail = (detailId = 0) => {
			store.dispatch('common/InternationalDetail', {
				id: detailId,
			}).then((res) => {
				data.taleDetail = res;
				data.taleDetail.title = data.taleDetail.title.replace(/#/g, '<br>');
				data.views = res.views ?? 0;
				trackContentView(store, CONTENT_VIEW_TYPES.international, detailId, data.views).then((v) => {
					data.views = v;
				});
				data.isListLoading = false;
				bus.emit('showFooter', true);
				wxshare(res);
			});
		};

		const wxshare = (share_data) => {
			const protocol = window.location.protocol;
			const hostname = window.location.hostname;
			let url = `${protocol}//${hostname}`;
			if (hostname.indexOf('www') === -1) {
				url = `${protocol}//www.${hostname}`;
			}
			url += route.fullPath;
			store.dispatch('common/Jssdk', { url }).then((res) => {
				wexinShare(res, {
					title: share_data.title,
					desc: '',
					link: url,
					imgUrl: getWechatShareImgUrl(store.state.common.siteInfo),
				});
			});
		};

		const viewBox = ref(null);
		const scroll = (val) => {
			if (!viewBox.value) return;
			viewBox.value.scrollIntoView({
				behavior: 'smooth',
				block: val === 'top' ? 'start' : 'end',
				inline: 'center',
			});
		};

		onMounted(async () => {
			getInternationalDetail(id);
			await nextTick();
			setTimeout(() => {
				data.isLoading = false;
				if (viewBox.value) {
					viewBox.value.scrollIntoView({
						behavior: 'smooth',
						block: 'start',
						inline: 'center',
					});
				}
			}, 500);
		});

		return {
			...toRefs(data),
			viewBox,
			scroll,
			getInternationalDetail,
			wxshare,
		};
	},
});
